import {IDataTag, IDataTagAssignment} from "~/interfaces/dataTagInterfaces";
import {DataTaggableProvider} from "~/providers/applications/dataTaggableProvider";
import {IObjectModel} from "~/interfaces/objectModelInterfaces";

export default function () {
  return {
    namespaced: true,
    state: {
      dataTags: [] as IDataTag[],
      dataTagAssignments: [] as IDataTagAssignment[],
    },
    mutations: {
      [MUTATIONS.setDataTags](state: { dataTags: IDataTag[] }, { dataTags }: { dataTags: IDataTag[] }): void {
        if (!Array.isArray(dataTags)) return;

        state.dataTags = dataTags;
      },
      [MUTATIONS.setDataTagAssignments](
        state: { dataTagAssignments: IDataTagAssignment[] },
        { dataTagAssignments }: { dataTagAssignments: IDataTagAssignment[] },
      ): void {
        if (!Array.isArray(dataTagAssignments)) return;

        state.dataTagAssignments = dataTagAssignments;
      },
    },
    actions: {
      [ACTIONS.fetchTaggedFieldInfo](
        { commit },
        { applicationId, dataTaggable, query }: {
          applicationId: string,
          dataTaggable: IObjectModel,
          query?: Partial<{
            viewId: string,
          }>,
        },
      ): void {
        DataTaggableProvider.fetchTaggedFieldInfo(
          applicationId,
          {
            id: dataTaggable.id,
            type: dataTaggable.modelType,
          },
          query,
        ).then(([res]) => {
          if (res.success) {
            commit(MUTATIONS.setDataTags, {dataTags: res.data_tags});
            commit(MUTATIONS.setDataTagAssignments, {dataTagAssignments: res.data_tag_assignments});
          }
        });
      },
    },
  };
}

export const STORE_NAME = 'dataTagAssignmentStore';

export const STATE = Object.freeze({
  dataTagAssignments: 'dataTagAssignments',
  dataTags: 'dataTags',
});

export const MUTATIONS = Object.freeze({
  setDataTagAssignments: 'setDataTagAssignments',
  setDataTags: 'setDataTags',
});

export const ACTIONS = Object.freeze({
  fetchTaggedFieldInfo: 'fetchTaggedFieldInfo',
});